/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { EnsureRewardsParticipantResponse, EnsureRewardsParticipantVars } from '../openapi-types.gen.js';

export type { EnsureRewardsParticipantResponse, EnsureRewardsParticipantVars } from '../openapi-types.gen.js';

export const useEnsureRewardsParticipant = createMutationHook<EnsureRewardsParticipantVars, EnsureRewardsParticipantResponse, unknown>({
  specName: 'useEnsureRewardsParticipant',
  path: '/v1/rewards/participant',
  method: 'POST',
  resolveUrl: (vars: EnsureRewardsParticipantVars) => `/v1/rewards/participant`,
  buildBody: (vars: EnsureRewardsParticipantVars) => ({ referralCode: vars.referralCode }),
  parseResponse: (raw: unknown): EnsureRewardsParticipantResponse => raw as EnsureRewardsParticipantResponse,
  
  
  
});
